import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, shallowCompare, Stack } from '@fluentui/react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import * as Services from '../../../../../Services/Services';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';

import { IAgeGoup } from '../../../../../Models/AgeGroups/IAgeGroup';
import { IAgeGroupApi } from '../../../../../Services/API/AgeGroup/IAgeGroupApi';
import { IEventItem } from '../../../../../Models/Event/IEventItem';
import { IEventApi } from '../../../../../Services/API/Event/IEventApi';
import { IEvent, emptyEvent } from '../../../../../Models/Event/IEvent';
import { EventListView } from './EventsListView';
import EventProperties from '../EventProperties/EventProperties';
import { IEventSreachFilter } from '../../../../../Models/Event/IEventSreachFilter';
import { IEventType } from '../../../../../Models/EventTypes/IEventType';
import { IEventTypeApi } from '../../../../../Services/API/EventType/IEventTypeApi';
import { IRoomApi } from '../../../../../Services/API/Room/IRoomApi';
import { useSearchParams } from 'react-router-dom';
import { isNumeric } from '../../../../../Tools/Validation';
import { IAdminApi } from '../../../../../Services/API/Admin/IAdminApi';
import { IUserListItem } from '../../../../../Models/Admin/IUserListItem';
import { getSchoolYears } from '../../../../Consts';
 
 

interface IEventListProps {

}

const dialogStyles = { main: { maxWidth: 450 } };

export const EventList: React.FunctionComponent<IEventListProps> = (props) => {

    const [eventItemList, setEventItemList] = React.useState<IEventItem[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isPropertiesOpened, setIsPropertiesOpened] = useBoolean(false);
    const [selectedEvent, setSelectedEvent] = React.useState<IEvent>()

    const [isDeleteDialogOpened, setIsDeleteDialogOpened] = useBoolean(false);
    const [eventTypeToDelete, setEventTypeToDelete] = React.useState({ id: 0, desc: "" });

    const [filter, setFilter] = React.useState<IEventSreachFilter>();
    const [eventTypes, setEventTypes] = React.useState<IEventType[]>([])
    const [ageGroups, setAgeGroups] = React.useState<IAgeGoup[]>([])
    const [district, setDistrict] = React.useState<string[]>([])
    const [params, setSearchParams] = useSearchParams();
    const [teachers, setTeachers] = React.useState<IUserListItem[]>([])
    const [schoolYears, setSchoolYears] = React.useState<number[]>([]);

    const labelId: string = useId('dialogLabel');
    const subTextId: string = useId('subTextLabel');

    const modalProps = React.useMemo(
        () => ({
            titleAriaId: labelId,
            subtitleAriaId: subTextId,
            isBlocking: false,
            styles: dialogStyles,
            dragOptions: undefined,
        }),
        [labelId, subTextId],
    );

    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const eventType = await eventTypeApi.getEventByFilterQuery(filter?.schoolYear, filter?.eventTypeId, filter?.district, filter?.ageGoroupId, filter?.teacherId, undefined, false);

        if (eventType.isSuccess && eventType.data) {
            setStatusMessage({ message: eventType.message, type: MessageBarType.success });
            setEventItemList(eventType.data);
        }
        else {
            setStatusMessage({ message: eventType.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadSchoolYears = async () => {

        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const schoolYears = await eventTypeApi.getAllSchoolYears();
        if (schoolYears.isSuccess && schoolYears.data) {
         
            setSchoolYears(schoolYears.data);
        }
        else {
            setStatusMessage({ message: schoolYears.message, type: MessageBarType.error });
        }
    }


    const loadEventTypes = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventTypeApi>(Services.EventTypeApi);
        const eventType = await eventTypeApi.getEventTypes(true);

        if (eventType.isSuccess && eventType.data) {
            setStatusMessage({ message: eventType.message, type: MessageBarType.success });
            setEventTypes(eventType.data);
        }
        else {
            setStatusMessage({ message: eventType.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadAgeGroups = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IAgeGroupApi>(Services.AgeGroupApi);
        const groups = await ageGroupApi.getAgeGroups("");

        if (groups.isSuccess && groups.data) {
            setStatusMessage({ message: groups.message, type: MessageBarType.success });
            setAgeGroups(groups.data);
        }
        else {
            setStatusMessage({ message: groups.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadTeachers = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const teachersApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
        const teachers = await teachersApi.getUserInRole("Teacher","");

        if (teachers.isSuccess && teachers.data) {
            setStatusMessage({ message: teachers.message, type: MessageBarType.success });
            setTeachers(teachers.data);
        }
        else {
            setStatusMessage({ message: teachers.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadDisticts = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IRoomApi>(Services.RoomApi);
        const groups = await ageGroupApi.getDistrict();

        if (groups.isSuccess && groups.data) {
            setStatusMessage({ message: groups.message, type: MessageBarType.success });
            setDistrict(groups.data.filter((v) => v !== ""));
        }
        else {
            setStatusMessage({ message: groups.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {

        filter && loadData();
    }, [filter])


    React.useEffect(() => {        
        loadSchoolYears();
        loadEventTypes();
        loadDisticts();
        loadAgeGroups();
        loadTeachers();

        var eventTypeId = params.get("eventTypeId");
        var district = params.get("district");
        var schoolYear = params.get("schoolYear");
        var ageGoroupId = params.get("ageGoroupId");
        setFilter({
            ageGoroupId: isNumeric(ageGoroupId) ? Number.parseInt(ageGoroupId) : undefined,
            district: district ? district : undefined,
            eventTypeId: isNumeric(eventTypeId) ? Number.parseInt(eventTypeId) : undefined,
            schoolYear: isNumeric(schoolYear) ? Number.parseInt(schoolYear) : getSchoolYears(new Date(Date.now()))[0],
            teacherId: undefined
        });


    }, [])

    const loadEvent = async (id: number) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventTypeApi.getEvent(id);
        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            setSelectedEvent(result.data);
            setIsPropertiesOpened.setTrue();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
        setIsDeleteDialogOpened.setFalse();
    }

    const deleteEventType = async (eventTypeId: number) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventTypeApi.deleteEvent(eventTypeId);

        if (result.isSuccess) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            await loadData();
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
        setIsDeleteDialogOpened.setFalse();
    }

    const addNewGroup = () => {
        setSelectedEvent(emptyEvent());
        setIsPropertiesOpened.setTrue();
    }

    const refresh = async (id: number) => {
        await loadData();
    }


    const selectGroup = (item: IEventItem) => {
        loadEvent(item.id);       
    }

    const deleteItemDialog = (id: number, desc: string) => {
        setEventTypeToDelete({ id: id, desc: desc });
        setIsDeleteDialogOpened.setTrue();
    }

    const deleteClick = async () => {
        await deleteEventType(eventTypeToDelete.id);
    }

    const propertyChanged = (key: string, value: any) => {
        setFilter({ ...filter, [key]: value });
    }


    return (<>
        <EventListView deleteItem={deleteItemDialog}
            selectItem={selectGroup}
            isLoading={isLoading}
            items={eventItemList}
            statusMessage={statusMessage}
            addGroup={addNewGroup}
            propertyChanged={propertyChanged}
            eventTypes={eventTypes}
            ageGroups={ageGroups}
            district={district}
            schoolYears={schoolYears}
            filter={filter}
            teachers={teachers}
        />


        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
        {selectedEvent ?
            <EventProperties item={selectedEvent}
                isOpen={isPropertiesOpened}
                close={setIsPropertiesOpened.setFalse}
                refresh={refresh}
            /> : null}
        {isDeleteDialogOpened ?
            <Dialog
                hidden={!isDeleteDialogOpened}
                onDismiss={setIsDeleteDialogOpened.setFalse}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Odstranit objekt',
                    closeButtonAriaLabel: 'Zavřít',
                    subText: `Opravdu chcete odstranit událost ${eventTypeToDelete.desc} ?`,
                }}
                modalProps={modalProps}
            >
                <DialogFooter>
                    <PrimaryButton onClick={deleteClick} text="Odstranit" />
                    <DefaultButton onClick={setIsDeleteDialogOpened.setFalse} text="Zrušit" />
                </DialogFooter>
            </Dialog> : null}
    </>
    )
}
